import jsParse from "@/main-page/jsParseEngine/jsParse";
import {ViewModel} from "@/main-page/jsParseEngine/ViewModel";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {useOpenSubPage} from "@/main-page/gridCellCtlShow/hooks/useOpenSubPage";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {deepClone} from 'xmgoing-utils';

/**
 * 让外层函数返回内部 asyncFoo 的 Promise，便于等待动作执行完成
 */
const wrapAsyncFooReturn = function (jsContent) {
  if (typeof jsContent !== 'string' || /\breturn\s+asyncFoo\s*\(/.test(jsContent)) {
    return jsContent;
  }
  return jsContent.replace(/\basyncFoo\s*\(\s*viewModel\s*,\s*inParams\s*\)\s*;/, 'return asyncFoo(viewModel, inParams);');
}

/**
 * 根据内容执行事件
 * @param content
 */
export const executeByContent = function ({jsContent, inParams, viewModel, waitAsync = false}) {
  if (jsContent && typeof jsContent==='string' &&jsContent.length > 0) {
    jsContent=jsContent.replace(/debugger;/g,"");
    const content = waitAsync ? wrapAsyncFooReturn(jsContent) : jsContent;
    const funFactory = jsParse.NewPublicFunction(content);
    if (typeof funFactory !== 'function') {
      console.error('jsContent parse failed', jsContent);
      return;
    }
    const fun = funFactory();
    return fun(viewModel, inParams);
  }else{
    if(typeof jsContent==="function"){
     return ((viewModel, inParams)=>{
        return jsContent(viewModel, inParams)
      })(viewModel, inParams);
    }
  }
}
/**
 * 调试代码
 * @param jsContent
 * @param inParams
 * @param viewModel
 */
export const executeDeBuggerByContent = function ({jsContent, inParams, viewModel, waitAsync = false}) {
  if (jsContent && jsContent.length > 0) {
    let content = jsContent.replace(/\(viewModel, inParams\){/," (viewModel, inParams) { ");
    if (waitAsync) {
      content = wrapAsyncFooReturn(content);
    }
    const funFactory = jsParse.NewPublicFunction(content);
    if (typeof funFactory !== 'function') {
      return;
    }
    const fun = funFactory();
    return fun(viewModel, inParams);
  }
}

/**
 * 执行单个事件 根据事件定义信息
 * @param eventItem
 */
export const executeEventItem = function ({eventItem, inParams, viewModel, waitAsync = false}) {
  viewModel.inParams=inParams;
  const {jsContent} = eventItem;
  if (jsContent == null) {
    return
  }
  return executeByContent({jsContent, inParams, viewModel, waitAsync});
}



export function useComEvent({events,useViewModel,exportCode=false}:any,functionList={},pageCtlInParams={}) {
  const {openSubComPage, openRouter} = useOpenSubPage();

  const pageModelsStore: any = usePageModelsStore();
  const dataSourceStore:any =useDataSourceStore();
  const {state} = storeToRefs(pageModelsStore);

  let viewModel = new ViewModel({viewPage:{}, pageModelsStore,dataSourceStore,state});
  viewModel.openSubComPage = openSubComPage;
  viewModel.openRouter = openRouter;

  const initWatchEvent=function (){
    if(events==null){
      return;
    }
    //对监听事件进行初始化
    unref(events)&&Array.isArray(unref(events))&&unref(events).filter((item) => {
      return item.value === 'watch'
    }).forEach((itemDb) => {
      if (itemDb && itemDb.watchList) {
        itemDb.watchList.forEach((watchItem) => {
          watch(() => unref(state)[watchItem["watchProp"]], () => {
            try {
              const viewPage = functionList;
              viewModel.initViewPage(viewPage);
              const inParams = {};
              const stateValues = unref(state)[watchItem["watchProp"]];
              if (typeof (stateValues) === "object") {
                Object.keys(stateValues).forEach((propName) => {
                  if (stateValues[propName]) {
                    inParams[propName] = stateValues[propName];
                  }
                })
              } else {
                inParams[watchItem["watchProp"]] = stateValues;
              }
              executeEventItem({eventItem: itemDb, inParams, viewModel});
            } catch (e) {
              console.error(e, '---watchEvent error')
            }
          }, {
            deep: true
          })
        })
      }
    })
  }

  /**
   * 执行用户定义的事件
   * @param userEvents
   */
  const executeUserEvent=function (userEvents,eventType,inParams, waitAsync=false) {
    if(userEvents&&Array.isArray(userEvents)&&userEvents.length>0){
      const userEventAry = (Array.isArray(unref(userEvents)) ? unref(userEvents) : []).filter((eventItem) => {
        return eventItem.eventType === (eventType || "click");
      })
      const jobs = userEventAry.map((eventItem: any) => {
        try {
          const viewPage = functionList;
          viewModel.initViewPage(viewPage);
          return executeEventItem({eventItem, inParams, viewModel, waitAsync});
        } catch (e) {
          console.error(e, "==clickEvent==")
        }
      })
      return Promise.allSettled(jobs);
    }
  }

  const clickEvent = function (eventType, inParams = {},userEvents?:any, waitAsync = false) {
    if(useViewModel){
      viewModel = useViewModel
    }
    const jobs: any[] = [];
    if(userEvents&&Array.isArray(userEvents)){
      jobs.push(executeUserEvent(userEvents,eventType,inParams, waitAsync));
    }
    const eventAry = unref(events)&&Array.isArray(unref(events))&&unref(events).filter((eventItem) => {
      return eventItem.eventType === (eventType || "click");
    })

    if (eventAry) {
      jobs.push(...unref(eventAry).map((eventItem: any) =>  {
        try {
          const viewPage = functionList;
          viewModel.initViewPage(viewPage);
          return executeEventItem({eventItem, inParams:inParams, viewModel, waitAsync});
        } catch (e) {
          console.error(e, "==clickEvent==")
        }
      }))
    }

    return Promise.allSettled(jobs)
  }

  const clickEventByItem=function (eventItem,inParams={},pageViewModal=null){
    if(pageViewModal){
      executeEventItem({eventItem, inParams: deepClone(inParams),viewModel:pageViewModal});
    }else{
      executeEventItem({eventItem, inParams: deepClone(inParams), viewModel});
    }
  }

  /**
   * 控件加载完成后执行
   */
  const initCtlEndEvent=function () {
    const eventAry =  unref(events)&&Array.isArray(unref(events))&&unref(events).filter((eventItem) => {
      return eventItem.eventType === ("initCtlEnd");
    });
    unref(events)&&Array.isArray(unref(events))&&unref(eventAry).forEach((eventItem: any) => {
      try {
        const viewPage = functionList;
        viewModel.initViewPage(viewPage);
        executeEventItem({eventItem, inParams:pageCtlInParams, viewModel});
      } catch (e) {
        console.error(e, "==clickEvent==")
      }
    })
  }

  /**
   * hasEvent
   * @param eventType
   */
  const hasEvent=function (eventType){
    const userEventAry = Array.isArray(unref(events))&&unref(events).filter((eventItem) => {
      return eventItem.eventType === eventType;
    })[0];
    if(userEventAry){
      return true
    }
    return  false;
  }


  onMounted(()=>{
    initWatchEvent();
    initCtlEndEvent();
  })
  return {
    executeUserEvent,
    viewModel,
    hasEvent,
    clickEventByItem,
    clickEvent
  }
}
